import React, { useRef, useState } from 'react';
import {
  Button,
  AddressInfo,
  formatAmountString,
  useSwitchToConfiguredChain, useConnectWalletModal,
} from '@airdao/ui-library';
import logo from './logo.svg';
import wallet from './wallet.svg';
import { NavLink } from 'react-router-dom';
import TailArrow from './TailArrow';
import { useAccount, useBalance, useDisconnect } from 'wagmi';

const HeaderWrapper = () => {
  const { address, chainId, connector } = useAccount();
  const { disconnect } = useDisconnect();
  const switchToAmb = useSwitchToConfiguredChain();
  const { toggleModal } = useConnectWalletModal();

  const ref = useRef();

  const [isAddressInfoOpen, setIsAddressInfoOpen] = useState(false);

  const { data: balance, isSuccess: isBalanceLoaded } = useBalance({
    address,
  });

  const handleLogout = () => {
    disconnect();
    setIsAddressInfoOpen(false);
  };

  // @ts-ignore
  const isSupportedChain = +process.env.REACT_APP_CHAIN_ID === chainId;

  return (
    <header className="header">
      <div className="header-container layout">
        <NavLink to="/" className="header__logo">
          <img src={logo} alt="logo" />
        </NavLink>
        <div className="header__links">
          <NavLink
            to="/"
            className={({ isActive }) =>
              `header__link ${isActive ? 'header__link_active' : ''}`
            }
          >
            Markets
          </NavLink>
          <NavLink
            to="/orders"
            className={({ isActive }) =>
              `header__link ${isActive ? 'header__link_active' : ''}`
            }
          >
            My Orders
          </NavLink>
          <NavLink
            to="/rewards"
            className={({ isActive }) =>
              `header__link ${isActive ? 'header__link_active' : ''}`
            }
          >
            Rewards
          </NavLink>
        </div>
        <a href="https://airdao.io/get-amb" target="_blank" className="header__get">
          <Button type="tetiary" size="medium">
            <span>Get AMB</span>
            <TailArrow />
          </Button>
        </a>
        {address ? (
          isSupportedChain && connector ? (
            <Button
              type="tetiary"
              size="medium"
              className="header__address"
              onClick={() => setIsAddressInfoOpen(true)}
            >
              <img
                src={connector.icon}
                alt={connector.name + ' icon'}
                className="header__address-icon"
              />
              <span className="header__address-text">
                {`${address.substring(0, 5)}...${address.substring(
                  address.length - 5,
                  address.length,
                )}`}
              </span>
            </Button>
          ) : (
            <Button
              onClick={() => switchToAmb()}
              size="medium"
              type="secondary"
              className="header__switch"
            >
              Switch to AMB-NET
            </Button>
          )
        ) : (
          <Button
            onClick={() => toggleModal()}
            size="medium"
            type="secondary"
            className="connect-btn"
          >
            Connect wallet
            <img src={wallet} alt="connect" />
          </Button>
        )}
        {isAddressInfoOpen && (
          // @ts-ignore
          <div className="address-info-wrapper" ref={ref}>
            <AddressInfo
              isOpen={isAddressInfoOpen}
              balance={isBalanceLoaded ? formatAmountString(balance.formatted) : '0'}
              logout={handleLogout}
              address={address}
              close={() => setIsAddressInfoOpen(false)}
              accountInfoRef={ref}
            />
          </div>
        )}
      </div>
    </header>
  );
};

export default HeaderWrapper;
